"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextColorInScale = void 0;
const hbIconsColors = {
    teal50: '#18c7c9',
    teal50_08: 'rgba(24, 199, 201, 0.08)',
    teal60: '#00adaf',
    blue10: '#a6b8f3',
    blue20: '#597eff',
    blue20_08: 'rgba(89, 126, 255, 0.08)',
    blue20_60: 'rgba(89, 126, 255, 0.6)',
    blue30: '#283f88',
    blue40: '#0c1f5c',
    blue50: '#001247',
    blue90: '#000021',
    white: '#ffffff',
    white_04: 'rgba(255, 255, 255, 0.4)',
    charcoal5: '#fafafb',
    charcoal10: '#f6f7f8',
    charcoal20: '#eeeff1',
    charcoal30: '#d1d3d9',
    charcoal40: '#a8adb8',
    charcoal50: '#767b84',
    charcoal60: '#383F49',
    charcoal70: '#24272b',
    green40: '#6ee59a',
    green50: '#4cc676',
    green60: '#249b4d',
    red50: '#ff6161',
    red50_08: 'rgba(255, 97, 97, 0.08)',
    red60: '#d73333',
    yellow50: '#ffdd0f',
    yellow60: '#e6bd00',
    skyblue50: '#59ccff',
    purple50: '#9271f5',
    violet50: '#7492fd',
    orange50: '#fbb16b',
    facebook: '#3b5998',
    instagram: '#d93175',
    google: '#df4a32',
    linkedin: '#007bb6',
    pinterest: '#cb2027',
    twitter: '#00b6f1',
    black: '#000000',
    black_07: 'rgba(0, 0, 0, 0.7)',
    black_08: 'rgba(0, 0, 0, 0.8)',
    black_01: 'rgba(0, 0, 0, 0.1)',
    blue_008: 'rgba(0, 18, 71, 0.08)',
    blue_015: 'rgba(0, 18, 71, 0.15)'
};
exports.default = hbIconsColors;
function nextColorInScale(color) {
    if (!color) {
        return null;
    }
    const matchFirstNumber = color.match(/[0-9]/);
    if (!matchFirstNumber) {
        return null;
    }
    const indexOfFirstNumber = matchFirstNumber.index;
    if (!indexOfFirstNumber) {
        return null;
    }
    const scale = color.substring(0, indexOfFirstNumber);
    const number = Number(color.substring(indexOfFirstNumber));
    if (!scale || !number) {
        return null;
    }
    const nextInScaleKey = `${scale}${number + 10}`;
    if (!hbIconsColors[nextInScaleKey]) {
        return null;
    }
    return nextInScaleKey;
}
exports.nextColorInScale = nextColorInScale;
//# sourceMappingURL=hb-icon-colors.js.map